module.exports = __webpack_public_path__ + "img/floor_OG2.14b063e8.svg";